const isValidVoiceSetting = (value) => {
  if (value === undefined || value === null) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  if (typeof value === 'boolean') return true;

  return true;
};

const validateKeys = ({ ...keys }) => {
  if (!keys) return false;

  const isValidKeys = !Object.keys(keys).some(
    (key) => !isValidVoiceSetting(keys[key])
  );

  return isValidKeys;
};

const hasConnectorFromItem = ({ connectors, itemId }) => {
  return connectors?.some(
    (connector) => String(connector.from) === String(itemId)
  );
};

const menuOptionHasConnector = ({ option, connectors, itemId }) => {
  return connectors?.some(
    (connector) =>
      String(connector.from) === String(itemId) &&
      String(option.description) ===
        String(connector.voiceSettings?.nmIvrResult)
  );
};

const isValidMenuOption = ({ menuItems, connectors, itemId }) => {
  if (menuItems?.length) {
    const menuOptionRequireHasNotConnector = menuItems.some(
      (option) =>
        option?.require_connection === true &&
        !menuOptionHasConnector({ option, connectors, itemId })
    );

    if (menuOptionRequireHasNotConnector) {
      return false;
    }
  }

  return true;
};

export const validateVoiceItem = ({ item, connectors }) => {
  const { _id: itemId, type, voiceSettings, menuItems } = item;

  if (!voiceSettings) {
    return false;
  }

  const {
    deIvrStep,
    deScriptTts,
    idIvrGrammar,
    qtScoreMin,
    qtMaxRepeat,
    qtMinDigitsDtmf,
    qtMaxDigitsDtmf,
    qtSecTimeoutDtmf,
    idIvrStatus,
    isExternalTransferCall,
    nuTransfer,
    mustNextStepWithIvrData,
    mustValidateIvrResultInDatabase,
    mustGenerateCodeTransfer,
    isCpc,
    deUrlWebApi,
    deParametersWebApi,
  } = voiceSettings;

  if (deIvrStep?.trim() === 'Digite a descrição') return false;

  switch (type) {
    case 'VoiceTransferirRamalInternoExterno':
      return validateKeys({
        deIvrStep,
        deScriptTts,
        isExternalTransferCall,
        nuTransfer,
        mustGenerateCodeTransfer,
        isCpc,
      });

    case 'VoiceTTSAudio': {
      const isValidKeys = validateKeys({
        deIvrStep,
        deScriptTts,
        idIvrStatus,
        isCpc,
      });
      const hasConnectorFrom = hasConnectorFromItem({ connectors, itemId });

      return isValidKeys && hasConnectorFrom;
    }

    case 'VoiceConfirmarVenda':
      return validateKeys({
        deIvrStep,
        isCpc,
      });

    case 'VoiceTTSAudioASR': {
      const isValidKeys = validateKeys({
        deIvrStep,
        deScriptTts,
        idIvrGrammar,
        qtMaxRepeat,
        qtScoreMin,
        idIvrStatus,
        mustValidateIvrResultInDatabase,
        mustNextStepWithIvrData,
        isCpc,
      });

      const isValidMenuOptionConnection = isValidMenuOption({
        menuItems,
        connectors,
        itemId,
      });

      return isValidKeys && isValidMenuOptionConnection;
    }

    case 'VoiceFinalizarAtendimento':
      return validateKeys({
        deIvrStep,
        deScriptTts,
        idIvrStatus,
        isCpc,
      });

    case 'VoiceTransferirRamalLocalizadorVendedor':
      return validateKeys({
        deIvrStep,
        deScriptTts,
        mustGenerateCodeTransfer,
        isCpc,
      });

    case 'VoiceAgendarMailing':
      return validateKeys({
        deIvrStep,
        deScriptTts,
        idIvrStatus,
        isCpc,
      });

    case 'VoiceTTSAudioDTMF': {
      const isValidKeys = validateKeys({
        deIvrStep,
        deScriptTts,
        qtMaxRepeat,
        qtMinDigitsDtmf,
        qtMaxDigitsDtmf,
        qtSecTimeoutDtmf,
        idIvrStatus,
        mustValidateIvrResultInDatabase,
        mustNextStepWithIvrData,
        isCpc,
      });

      const isValidMenuOptionConnection = isValidMenuOption({
        menuItems,
        connectors,
        itemId,
      });

      return isValidKeys && isValidMenuOptionConnection;
    }

    case 'VoiceWebApiList':
      return validateKeys({
        deIvrStep,
        deUrlWebApi,
        deParametersWebApi,
        isCpc,
      });

    case 'VoiceSMS': {
      const isValidKeys = validateKeys({
        deIvrStep,
        isCpc,
      });

      const isValidMenuOptionConnection = isValidMenuOption({
        menuItems,
        connectors,
        itemId,
      });

      return isValidKeys && isValidMenuOptionConnection;
    }

    default:
      return false;
  }
};
